(function () {
  function isCustomerLoggedIn() {
    return document.body.classList.contains('customer-logged-in');
  }

  function goToLogin() {
    const checkoutUrl =
      window.location.pathname +
      window.location.search;

    const loginUrl =
      '/account/login?return_to=' +
      encodeURIComponent('/checkout');

    window.location.href = loginUrl;
  }

  function interceptCheckout(event) {
    const target = event.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
    );

    if (!target) return;

    if (!isCustomerLoggedIn()) {
      event.preventDefault();
      event.stopPropagation();

      goToLogin();
    }
  }

  document.addEventListener('click', interceptCheckout, true);

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (
      form &&
      (
        form.action.includes('/checkout') ||
        form.querySelector('[name="checkout"]')
      )
    ) {
      if (!isCustomerLoggedIn()) {
        event.preventDefault();
        event.stopPropagation();

        goToLogin();
      }
    }
  }, true);
})();